/* 
import { useEffect } from "react";

const AdminSyncAlert = () => {
  useEffect(() => {
    console.log("AdminSyncAlert mounted");

    // Automatically start sync when component mounts
    syncStore();
  }, []);

  function syncStore() {
    const overlay = document.getElementById("syncOverlay");
    const closeBtn = document.getElementById("closeOverlay");
    const syncProgress = document.getElementById("syncProgress");
    const overlayTitle = document.querySelector(".overlay-title");
    const overlayMessage = document.querySelector(".overlay-message");
    const loader = document.querySelector(".loader");

    // Show overlay
    overlay.classList.add("active");

    // Simulate sync process
    setTimeout(() => {
      // Show progress items
      syncProgress.style.display = "block";

      // After progress is shown, update UI
      setTimeout(() => {
        // Hide loader
        loader.style.display = "none";

        // Update title and message
        overlayTitle.textContent = "Synchronization Complete!";
        overlayMessage.textContent = "Your store data has been successfully synced with the staff portal.";

        // Show close button
        closeBtn.style.display = "inline-block";

        // Update last sync time in the card
        const lastSyncTime = document.getElementById("lastSyncTime");
        const now = new Date();
        const timeString = now.toLocaleTimeString("en-US", {
          hour: "numeric",
          minute: "2-digit",
          hour12: false,
        });
        lastSyncTime.textContent = `Today at ${timeString}`;
      }, 2000);
    }, 1500);
  }

  function closeOverlay() {
    const overlay = document.getElementById("syncOverlay");
    const closeBtn = document.getElementById("closeOverlay");
    const syncProgress = document.getElementById("syncProgress");
    const overlayTitle = document.querySelector(".overlay-title");
    const overlayMessage = document.querySelector(".overlay-message");
    const loader = document.querySelector(".loader");

    // Hide overlay
    overlay.classList.remove("active");

    // Reset overlay state for next use
    setTimeout(() => {
      loader.style.display = "block";
      overlayTitle.textContent = "Synchronizing Store";
      overlayMessage.textContent = "Please wait while we sync your data with the staff portal...";
      syncProgress.style.display = "none";
      closeBtn.style.display = "none";
    }, 300);
  }

  // Add event listener to close button
   document.getElementById("closeOverlay").addEventListener("click", closeOverlay);

  // Close overlay when clicking outside
  document.getElementById("syncOverlay").addEventListener("click", function (e) {
    if (e.target === this) {
      closeOverlay();
    }
  });

  return (
    <div class='overlay' id='syncOverlay'>
      <div class='overlay-content'>
        <div class='loader'>
          <div class='loader-ring'></div>
          <div class='loader-icon'>🔄</div>
        </div>
        <h3 class='overlay-title'>Synchronizing Store</h3>
        <p class='overlay-message'>Please wait while we sync your data with the staff portal...</p>

        <div class='sync-progress' id='syncProgress' style='display: none;'>
          <div class='progress-item'>
            <span class='progress-check'>✓</span>
            <span>Employee schedules updated</span>
          </div>
          <div class='progress-item'>
            <span class='progress-check' style='animation-delay: 0.5s;'>
              ✓
            </span>
            <span>Inventory synchronized</span>
          </div>
          <div class='progress-item'>
            <span class='progress-check' style='animation-delay: 1s;'>
              ✓
            </span>
            <span>Sales data refreshed</span>
          </div>
        </div>

        <button class='overlay-close-btn' id='closeOverlay' style='display: none;'>
          Close
        </button>
      </div>
    </div>
  );
};

export default AdminSyncAlert;
 */

import "./index.css";
import React, { useEffect, useState, useRef } from "react";

const AdminSyncAlert = ({ IsSyncOnGoing }) => {
  const [active, setActive] = useState(false); // overlay visible
  const [loading, setLoading] = useState(true); // spinner visible
  const [showProgress, setShowProgress] = useState(false);
  const [done, setDone] = useState(false); // completed state
  const [lastSyncText, setLastSyncText] = useState(""); // e.g., "Today at 14:32"

  const timeoutsRef = useRef([]);
  console.log(IsSyncOnGoing);

  // Auto-start sync when mounted
  useEffect(() => {
    // Step 1: after 1.5s show progress list
    /*    */
    if (IsSyncOnGoing) {
      setActive(true);
      setLoading(true);
    } else {
      timeoutsRef.current.push(
        setTimeout(() => {
          setShowProgress(true);

          // Step 2: after 2s mark complete, hide loader, show close
          timeoutsRef.current.push(
            setTimeout(() => {
              setLoading(false);
              setDone(true);
              setTimeout(() => {
                setActive(false);
              }, 1000);
            }, 2500)
          );
        }, 1500)
      );
    }

    // Cleanup: clear pending timers
    return () => {
      timeoutsRef.current.forEach(clearTimeout);
      timeoutsRef.current = [];
    };
  }, [IsSyncOnGoing]);

  const closeOverlay = () => {
    setActive(false);

    // Optional: reset internal state shortly after close (for next use)
    timeoutsRef.current.push(
      setTimeout(() => {
        setLoading(true);
        setShowProgress(false);
        setDone(false);
      }, 300)
    );
  };

  // Close when clicking the backdrop (but not the content)
  const onBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      closeOverlay();
    }
  };
  console.log(active);

  if (!active) return null;

  return (
    <div className='overlay active' id='syncOverlay' onClick={onBackdropClick}>
      <div className='overlay-content'>
        {loading && (
          <div className='loader'>
            <div className='loader-ring'></div>
            <div className='loader-icon'>🔄</div>
          </div>
        )}

        <h3 className='overlay-title'>{done ? "Synchronization Complete!" : "Synchronizing Store"}</h3>

        <p className='overlay-message'>
          {done ? "Your store data has been successfully synced with the staff portal." : "Please wait while we sync your data with the staff portal..."}
        </p>

        {showProgress && (
          <div className='sync-progress' id='syncProgress'>
            <div className='progress-item'>
              <span className='progress-check'>✓</span>
              <span>Employee schedules updated</span>
            </div>
            <div className='progress-item'>
              <span className='progress-check' style={{ animationDelay: "0.5s" }}>
                ✓
              </span>
              <span>Inventory synchronized</span>
            </div>
            <div className='progress-item'>
              <span className='progress-check' style={{ animationDelay: "1s" }}>
                ✓
              </span>
              <span>Sales data refreshed</span>
            </div>
          </div>
        )}

        {done && (
          <button className='overlay-close-btn' id='closeOverlay' onClick={closeOverlay}>
            Close
          </button>
        )}
      </div>
    </div>
  );
};

export default AdminSyncAlert;
